import { library } from '@fortawesome/fontawesome-svg-core';
import * as Brands from '@fortawesome/free-brands-svg-icons';

Object.values(Brands).forEach(icon => {
  if (icon?.iconName) {
    library.add(icon);
  }
});
